import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { HexString } from 'src/app/types/@types/hex-string';

export type NegativeNumberFormat = 'neg' | 'neg-paren' | 'paren';

export type NegativeNumberFormatting = {
	format: NegativeNumberFormat;
	color: HexString | string;
}

@Component({
	selector: 'app-negative-numbers-sel',
	templateUrl: './negative-numbers-sel.component.html',
	styleUrls: ['./negative-numbers-sel.component.scss']
})
export class NegativeNumbersSelComponent implements OnInit {

	public format: NegativeNumberFormat = 'neg'
	public color: HexString = '#000';
	@Input()
	
	@Input('value')
	set value(val: NegativeNumberFormatting) {
		let newFormat = false;
		let newColor = false;
		if (!!val) {
			if (this.format !== val.format) {
				this.format = val.format;
				newFormat = true;
			}
			if (this.color !== val.color) {
				this.color = val.color;
				newColor = true;
			}
		}
		if (newFormat || newColor) {
			this.valueChange.emit({ format: this.format, color: this.color });
		}
	}
	get value(): NegativeNumberFormatting {
		return {
			format: this.format,
			color: this.color
		}
	}
	@Output()
	public valueChange = new EventEmitter<NegativeNumberFormatting>();

	constructor() {
	}
	Update() {
		this.valueChange.emit(this.value);
	}
	ngOnInit(): void {
	}

}
